var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/graphql-tag/node_modules/tslib/tslib.js
var require_tslib = __commonJS({
  "../../node_modules/graphql-tag/node_modules/tslib/tslib.js"(exports, module) {
    var __extends2;
    var __assign2;
    var __rest2;
    var __decorate2;
    var __param2;
    var __metadata2;
    var __awaiter2;
    var __generator2;
    var __exportStar2;
    var __values2;
    var __read2;
    var __spread2;
    var __spreadArrays2;
    var __spreadArray2;
    var __await2;
    var __asyncGenerator2;
    var __asyncDelegator2;
    var __asyncValues2;
    var __makeTemplateObject2;
    var __importStar2;
    var __importDefault2;
    var __classPrivateFieldGet2;
    var __classPrivateFieldSet2;
    var __classPrivateFieldIn2;
    var __createBinding2;
    (function(factory) {
      var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
      if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function(exports2) {
          factory(createExporter(root, createExporter(exports2)));
        });
      } else if (typeof module === "object" && typeof module.exports === "object") {
        factory(createExporter(root, createExporter(module.exports)));
      } else {
        factory(createExporter(root));
      }
      function createExporter(exports2, previous) {
        if (exports2 !== root) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports2, "__esModule", { value: true });
          } else {
            exports2.__esModule = true;
          }
        }
        return function(id, v) {
          return exports2[id] = previous ? previous(id, v) : v;
        };
      }
    })(function(exporter) {
      var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, b) {
        d.__proto__ = b;
      } || function(d, b) {
        for (var p in b)
          if (Object.prototype.hasOwnProperty.call(b, p))
            d[p] = b[p];
      };
      __extends2 = function(d, b) {
        if (typeof b !== "function" && b !== null)
          throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
      __assign2 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
              t[p] = s[p];
        }
        return t;
      };
      __rest2 = function(s, e) {
        var t = {};
        for (var p in s)
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
          }
        return t;
      };
      __decorate2 = function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i = decorators.length - 1; i >= 0; i--)
            if (d = decorators[i])
              r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };
      __param2 = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata2 = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter2 = function(thisArg, _arguments, P, generator) {
        function adopt(value) {
          return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
          });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e) {
              reject(e);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e) {
              reject(e);
            }
          }
          function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator2 = function(thisArg, body) {
        var _ = { label: 0, sent: function() {
          if (t[0] & 1)
            throw t[1];
          return t[1];
        }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
          return this;
        }), g;
        function verb(n) {
          return function(v) {
            return step([n, v]);
          };
        }
        function step(op) {
          if (f)
            throw new TypeError("Generator is already executing.");
          while (_)
            try {
              if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                return t;
              if (y = 0, t)
                op = [op[0] & 2, t.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t = op;
                  break;
                case 4:
                  _.label++;
                  return { value: op[1], done: false };
                case 5:
                  _.label++;
                  y = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _.ops.pop();
                  _.trys.pop();
                  continue;
                default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _ = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                    _.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _.label < t[1]) {
                    _.label = t[1];
                    t = op;
                    break;
                  }
                  if (t && _.label < t[2]) {
                    _.label = t[2];
                    _.ops.push(op);
                    break;
                  }
                  if (t[2])
                    _.ops.pop();
                  _.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _);
            } catch (e) {
              op = [6, e];
              y = 0;
            } finally {
              f = t = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __exportStar2 = function(m, o) {
        for (var p in m)
          if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p))
            __createBinding2(o, m, p);
      };
      __createBinding2 = Object.create ? function(o, m, k, k2) {
        if (k2 === void 0)
          k2 = k;
        var desc = Object.getOwnPropertyDescriptor(m, k);
        if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
          desc = { enumerable: true, get: function() {
            return m[k];
          } };
        }
        Object.defineProperty(o, k2, desc);
      } : function(o, m, k, k2) {
        if (k2 === void 0)
          k2 = k;
        o[k2] = m[k];
      };
      __values2 = function(o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m)
          return m.call(o);
        if (o && typeof o.length === "number")
          return {
            next: function() {
              if (o && i >= o.length)
                o = void 0;
              return { value: o && o[i++], done: !o };
            }
          };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read2 = function(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m)
          return o;
        var i = m.call(o), r, ar = [], e;
        try {
          while ((n === void 0 || n-- > 0) && !(r = i.next()).done)
            ar.push(r.value);
        } catch (error) {
          e = { error };
        } finally {
          try {
            if (r && !r.done && (m = i["return"]))
              m.call(i);
          } finally {
            if (e)
              throw e.error;
          }
        }
        return ar;
      };
      __spread2 = function() {
        for (var ar = [], i = 0; i < arguments.length; i++)
          ar = ar.concat(__read2(arguments[i]));
        return ar;
      };
      __spreadArrays2 = function() {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++)
          s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
          for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
        return r;
      };
      __spreadArray2 = function(to, from, pack) {
        if (pack || arguments.length === 2)
          for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
              if (!ar)
                ar = Array.prototype.slice.call(from, 0, i);
              ar[i] = from[i];
            }
          }
        return to.concat(ar || Array.prototype.slice.call(from));
      };
      __await2 = function(v) {
        return this instanceof __await2 ? (this.v = v, this) : new __await2(v);
      };
      __asyncGenerator2 = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g = generator.apply(thisArg, _arguments || []), i, q = [];
        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
          return this;
        }, i;
        function verb(n) {
          if (g[n])
            i[n] = function(v) {
              return new Promise(function(a, b) {
                q.push([n, v, a, b]) > 1 || resume(n, v);
              });
            };
        }
        function resume(n, v) {
          try {
            step(g[n](v));
          } catch (e) {
            settle(q[0][3], e);
          }
        }
        function step(r) {
          r.value instanceof __await2 ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f, v) {
          if (f(v), q.shift(), q.length)
            resume(q[0][0], q[0][1]);
        }
      };
      __asyncDelegator2 = function(o) {
        var i, p;
        return i = {}, verb("next"), verb("throw", function(e) {
          throw e;
        }), verb("return"), i[Symbol.iterator] = function() {
          return this;
        }, i;
        function verb(n, f) {
          i[n] = o[n] ? function(v) {
            return (p = !p) ? { value: __await2(o[n](v)), done: n === "return" } : f ? f(v) : v;
          } : f;
        }
      };
      __asyncValues2 = function(o) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m = o[Symbol.asyncIterator], i;
        return m ? m.call(o) : (o = typeof __values2 === "function" ? __values2(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
          return this;
        }, i);
        function verb(n) {
          i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
              v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
          };
        }
        function settle(resolve, reject, d, v) {
          Promise.resolve(v).then(function(v2) {
            resolve({ value: v2, done: d });
          }, reject);
        }
      };
      __makeTemplateObject2 = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      var __setModuleDefault = Object.create ? function(o, v) {
        Object.defineProperty(o, "default", { enumerable: true, value: v });
      } : function(o, v) {
        o["default"] = v;
      };
      __importStar2 = function(mod) {
        if (mod && mod.__esModule)
          return mod;
        var result = {};
        if (mod != null) {
          for (var k in mod)
            if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
              __createBinding2(result, mod, k);
        }
        __setModuleDefault(result, mod);
        return result;
      };
      __importDefault2 = function(mod) {
        return mod && mod.__esModule ? mod : { "default": mod };
      };
      __classPrivateFieldGet2 = function(receiver, state, kind, f) {
        if (kind === "a" && !f)
          throw new TypeError("Private accessor was defined without a getter");
        if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
          throw new TypeError("Cannot read private member from an object whose class did not declare it");
        return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
      };
      __classPrivateFieldSet2 = function(receiver, state, value, kind, f) {
        if (kind === "m")
          throw new TypeError("Private method is not writable");
        if (kind === "a" && !f)
          throw new TypeError("Private accessor was defined without a setter");
        if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
          throw new TypeError("Cannot write private member to an object whose class did not declare it");
        return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
      };
      __classPrivateFieldIn2 = function(state, receiver) {
        if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function")
          throw new TypeError("Cannot use 'in' operator on non-object");
        return typeof state === "function" ? receiver === state : state.has(receiver);
      };
      exporter("__extends", __extends2);
      exporter("__assign", __assign2);
      exporter("__rest", __rest2);
      exporter("__decorate", __decorate2);
      exporter("__param", __param2);
      exporter("__metadata", __metadata2);
      exporter("__awaiter", __awaiter2);
      exporter("__generator", __generator2);
      exporter("__exportStar", __exportStar2);
      exporter("__createBinding", __createBinding2);
      exporter("__values", __values2);
      exporter("__read", __read2);
      exporter("__spread", __spread2);
      exporter("__spreadArrays", __spreadArrays2);
      exporter("__spreadArray", __spreadArray2);
      exporter("__await", __await2);
      exporter("__asyncGenerator", __asyncGenerator2);
      exporter("__asyncDelegator", __asyncDelegator2);
      exporter("__asyncValues", __asyncValues2);
      exporter("__makeTemplateObject", __makeTemplateObject2);
      exporter("__importStar", __importStar2);
      exporter("__importDefault", __importDefault2);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet2);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet2);
      exporter("__classPrivateFieldIn", __classPrivateFieldIn2);
    });
  }
});

// lib/NotifiService.ts
import { v4 as uuid } from "uuid";

// ../../node_modules/graphql-tag/node_modules/tslib/modules/index.js
var import_tslib = __toESM(require_tslib(), 1);
var {
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __metadata,
  __awaiter,
  __generator,
  __exportStar,
  __createBinding,
  __values,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar,
  __importDefault,
  __classPrivateFieldGet,
  __classPrivateFieldSet,
  __classPrivateFieldIn
} = import_tslib.default;

// ../../node_modules/graphql-tag/lib/index.js
import { parse } from "graphql";
var docCache = /* @__PURE__ */ new Map();
var fragmentSourceMap = /* @__PURE__ */ new Map();
var printFragmentWarnings = true;
var experimentalFragmentVariables = false;
function normalize(string) {
  return string.replace(/[\s,]+/g, " ").trim();
}
function cacheKeyFromLoc(loc) {
  return normalize(loc.source.body.substring(loc.start, loc.end));
}
function processFragments(ast) {
  var seenKeys = /* @__PURE__ */ new Set();
  var definitions = [];
  ast.definitions.forEach(function(fragmentDefinition) {
    if (fragmentDefinition.kind === "FragmentDefinition") {
      var fragmentName = fragmentDefinition.name.value;
      var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc);
      var sourceKeySet = fragmentSourceMap.get(fragmentName);
      if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
        if (printFragmentWarnings) {
          console.warn("Warning: fragment with name " + fragmentName + " already exists.\ngraphql-tag enforces all fragment names across your application to be unique; read more about\nthis in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
        }
      } else if (!sourceKeySet) {
        fragmentSourceMap.set(fragmentName, sourceKeySet = /* @__PURE__ */ new Set());
      }
      sourceKeySet.add(sourceKey);
      if (!seenKeys.has(sourceKey)) {
        seenKeys.add(sourceKey);
        definitions.push(fragmentDefinition);
      }
    } else {
      definitions.push(fragmentDefinition);
    }
  });
  return __assign(__assign({}, ast), { definitions });
}
function stripLoc(doc) {
  var workSet = new Set(doc.definitions);
  workSet.forEach(function(node) {
    if (node.loc)
      delete node.loc;
    Object.keys(node).forEach(function(key) {
      var value = node[key];
      if (value && typeof value === "object") {
        workSet.add(value);
      }
    });
  });
  var loc = doc.loc;
  if (loc) {
    delete loc.startToken;
    delete loc.endToken;
  }
  return doc;
}
function parseDocument(source) {
  var cacheKey = normalize(source);
  if (!docCache.has(cacheKey)) {
    var parsed = parse(source, {
      experimentalFragmentVariables,
      allowLegacyFragmentVariables: experimentalFragmentVariables
    });
    if (!parsed || parsed.kind !== "Document") {
      throw new Error("Not a valid GraphQL document.");
    }
    docCache.set(cacheKey, stripLoc(processFragments(parsed)));
  }
  return docCache.get(cacheKey);
}
function gql(literals) {
  var args = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }
  if (typeof literals === "string") {
    literals = [literals];
  }
  var result = literals[0];
  args.forEach(function(arg, i) {
    if (arg && arg.kind === "Document") {
      result += arg.loc.source.body;
    } else {
      result += arg;
    }
    result += literals[i + 1];
  });
  return parseDocument(result);
}
function resetCaches() {
  docCache.clear();
  fragmentSourceMap.clear();
}
function disableFragmentWarnings() {
  printFragmentWarnings = false;
}
function enableExperimentalFragmentVariables() {
  experimentalFragmentVariables = true;
}
function disableExperimentalFragmentVariables() {
  experimentalFragmentVariables = false;
}
var extras = {
  gql,
  resetCaches,
  disableFragmentWarnings,
  enableExperimentalFragmentVariables,
  disableExperimentalFragmentVariables
};
(function(gql_1) {
  gql_1.gql = extras.gql, gql_1.resetCaches = extras.resetCaches, gql_1.disableFragmentWarnings = extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = extras.disableExperimentalFragmentVariables;
})(gql || (gql = {}));
gql["default"] = gql;
var lib_default = gql;

// lib/gql/generated.ts
var FilterFragmentFragmentDoc = lib_default`
    fragment FilterFragment on Filter {
  id
  name
  filterType
}
    `;
var SourceFragmentFragmentDoc = lib_default`
    fragment SourceFragment on Source {
  id
  name
  type
  blockchainAddress
  applicableFilters {
    ...FilterFragment
  }
}
    ${FilterFragmentFragmentDoc}`;
var SourceGroupFragmentFragmentDoc = lib_default`
    fragment SourceGroupFragment on SourceGroup {
  id
  name
  sources {
    ...SourceFragment
  }
}
    ${SourceFragmentFragmentDoc}`;
var EmailTargetFragmentFragmentDoc = lib_default`
    fragment EmailTargetFragment on EmailTarget {
  emailAddress
  id
  isConfirmed
  name
}
    `;
var SmsTargetFragmentFragmentDoc = lib_default`
    fragment SmsTargetFragment on SmsTarget {
  id
  isConfirmed
  name
  phoneNumber
}
    `;
var TelegramTargetFragmentFragmentDoc = lib_default`
    fragment TelegramTargetFragment on TelegramTarget {
  id
  isConfirmed
  name
  telegramId
  confirmationUrl
}
    `;
var WebhookTargetFragmentFragmentDoc = lib_default`
    fragment WebhookTargetFragment on WebhookTarget {
  id
  url
  status
  format
  headers {
    key
    value
  }
  name
}
    `;
var TargetGroupFragmentFragmentDoc = lib_default`
    fragment TargetGroupFragment on TargetGroup {
  id
  name
  emailTargets {
    ...EmailTargetFragment
  }
  smsTargets {
    ...SmsTargetFragment
  }
  telegramTargets {
    ...TelegramTargetFragment
  }
  webhookTargets {
    ...WebhookTargetFragment
  }
}
    ${EmailTargetFragmentFragmentDoc}
${SmsTargetFragmentFragmentDoc}
${TelegramTargetFragmentFragmentDoc}
${WebhookTargetFragmentFragmentDoc}`;
var AlertFragmentFragmentDoc = lib_default`
    fragment AlertFragment on Alert {
  id
  groupName
  name
  filterOptions
  filter {
    ...FilterFragment
  }
  sourceGroup {
    ...SourceGroupFragment
  }
  targetGroup {
    ...TargetGroupFragment
  }
}
    ${FilterFragmentFragmentDoc}
${SourceGroupFragmentFragmentDoc}
${TargetGroupFragmentFragmentDoc}`;
var NotificationHistoryEntryFragmentFragmentDoc = lib_default`
    fragment NotificationHistoryEntryFragment on NotificationHistoryEntry {
  id
  category
  createdDate
  read
  detail {
    __typename
    ... on BroadcastMessageEventDetails {
      type
      subject
      message
    }
    ... on GenericEventDetails {
      notificationTypeName
      sourceName
      genericMessage: message
      action {
        name
        url
      }
    }
  }
}
    `;
var PageInfoFragmentFragmentDoc = lib_default`
    fragment PageInfoFragment on PageInfo {
  hasNextPage
  endCursor
}
    `;
var TenantConfigFragmentFragmentDoc = lib_default`
    fragment TenantConfigFragment on TenantConfig {
  id
  type
  dataJson
}
    `;
var AuthorizationFragmentFragmentDoc = lib_default`
    fragment AuthorizationFragment on Authorization {
  token
  expiry
}
    `;
var UserFragmentFragmentDoc = lib_default`
    fragment UserFragment on User {
  email
  emailConfirmed
  authorization {
    ...AuthorizationFragment
  }
  roles
}
    ${AuthorizationFragmentFragmentDoc}`;
var UserTopicFragmentFragmentDoc = lib_default`
    fragment UserTopicFragment on UserTopic {
  name
  topicName
  targetCollections
  targetTemplate
}
    `;
var BeginLogInByTransactionDocument = lib_default`
    mutation beginLogInByTransaction($walletAddress: String!, $walletBlockchain: WalletBlockchain!, $dappAddress: String!) {
  beginLogInByTransaction(
    beginLogInByTransactionInput: {walletAddress: $walletAddress, walletBlockchain: $walletBlockchain, dappAddress: $dappAddress}
  ) {
    nonce
  }
}
    `;
var BroadcastMessageDocument = lib_default`
    mutation broadcastMessage($idempotencyKey: String, $topicName: String!, $targetTemplates: [KeyValuePairOfTargetTypeAndStringInput!], $variables: [KeyValuePairOfStringAndStringInput!], $timestamp: Long!, $walletBlockchain: WalletBlockchain!, $signature: String!) {
  broadcastMessage(
    broadcastMessageInput: {idempotencyKey: $idempotencyKey, sourceAddress: $topicName, targetTemplates: $targetTemplates, variables: $variables, timestamp: $timestamp, walletBlockchain: $walletBlockchain}
    signature: $signature
  ) {
    id
  }
}
    `;
var CompleteLogInByTransactionDocument = lib_default`
    mutation completeLogInByTransaction($walletAddress: String!, $walletBlockchain: WalletBlockchain!, $dappAddress: String!, $randomUuid: String!, $transactionSignature: String!) {
  completeLogInByTransaction(
    completeLogInByTransactionInput: {walletAddress: $walletAddress, walletBlockchain: $walletBlockchain, dappAddress: $dappAddress, randomUuid: $randomUuid, transactionSignature: $transactionSignature}
  ) {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;
var CreateAlertDocument = lib_default`
    mutation createAlert($name: String!, $sourceGroupId: String!, $filterId: String!, $targetGroupId: String!, $filterOptions: String!, $groupName: String!) {
  createAlert(
    alertInput: {name: $name, sourceGroupId: $sourceGroupId, filterId: $filterId, targetGroupId: $targetGroupId, filterOptions: $filterOptions, groupName: $groupName}
  ) {
    ...AlertFragment
  }
}
    ${AlertFragmentFragmentDoc}`;
var CreateEmailTargetDocument = lib_default`
    mutation createEmailTarget($name: String!, $value: String!) {
  createEmailTarget(createTargetInput: {name: $name, value: $value}) {
    ...EmailTargetFragment
  }
}
    ${EmailTargetFragmentFragmentDoc}`;
var CreateSmsTargetDocument = lib_default`
    mutation createSmsTarget($name: String!, $value: String!) {
  createSmsTarget(createTargetInput: {name: $name, value: $value}) {
    ...SmsTargetFragment
  }
}
    ${SmsTargetFragmentFragmentDoc}`;
var CreateSourceDocument = lib_default`
    mutation createSource($name: String, $blockchainAddress: String!, $type: SourceType!) {
  createSource(
    createSourceInput: {name: $name, blockchainAddress: $blockchainAddress, type: $type}
  ) {
    ...SourceFragment
  }
}
    ${SourceFragmentFragmentDoc}`;
var CreateSourceGroupDocument = lib_default`
    mutation createSourceGroup($name: String!, $sourceIds: [String!]!) {
  createSourceGroup(sourceGroupInput: {name: $name, sourceIds: $sourceIds}) {
    ...SourceGroupFragment
  }
}
    ${SourceGroupFragmentFragmentDoc}`;
var CreateTargetGroupDocument = lib_default`
    mutation createTargetGroup($name: String!, $emailTargetIds: [String!]!, $smsTargetIds: [String!]!, $telegramTargetIds: [String!]!, $webhookTargetIds: [String!]!) {
  createTargetGroup(
    targetGroupInput: {name: $name, emailTargetIds: $emailTargetIds, smsTargetIds: $smsTargetIds, telegramTargetIds: $telegramTargetIds, webhookTargetIds: $webhookTargetIds}
  ) {
    ...TargetGroupFragment
  }
}
    ${TargetGroupFragmentFragmentDoc}`;
var CreateTelegramTargetDocument = lib_default`
    mutation createTelegramTarget($name: String!, $value: String!) {
  createTelegramTarget(createTargetInput: {name: $name, value: $value}) {
    ...TelegramTargetFragment
  }
}
    ${TelegramTargetFragmentFragmentDoc}`;
var CreateWebhookTargetDocument = lib_default`
    mutation createWebhookTarget($name: String!, $url: String!, $format: WebhookPayloadFormat!, $headers: [KeyValuePairOfStringAndStringInput!]!) {
  createWebhookTarget(
    createTargetInput: {name: $name, url: $url, format: $format, headers: $headers}
  ) {
    ...WebhookTargetFragment
  }
}
    ${WebhookTargetFragmentFragmentDoc}`;
var DeleteAlertDocument = lib_default`
    mutation deleteAlert($id: String!) {
  deleteAlert(alertId: $id) {
    id
  }
}
    `;
var DeleteSourceGroupDocument = lib_default`
    mutation deleteSourceGroup($id: String!) {
  deleteSourceGroup(sourceGroupInput: {id: $id}) {
    id
  }
}
    `;
var DeleteTargetGroupDocument = lib_default`
    mutation deleteTargetGroup($id: String!) {
  deleteTargetGroup(targetGroupInput: {id: $id}) {
    id
  }
}
    `;
var LogInFromDappDocument = lib_default`
    mutation logInFromDapp($walletBlockchain: WalletBlockchain!, $walletPublicKey: String!, $dappAddress: String!, $timestamp: Long!, $signature: String!, $accountId: String) {
  logInFromDapp(
    dappLogInInput: {walletBlockchain: $walletBlockchain, walletPublicKey: $walletPublicKey, dappAddress: $dappAddress, timestamp: $timestamp, accountId: $accountId}
    signature: $signature
  ) {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;
var RefreshAuthorizationDocument = lib_default`
    mutation refreshAuthorization {
  refreshAuthorization {
    ...AuthorizationFragment
  }
}
    ${AuthorizationFragmentFragmentDoc}`;
var SendEmailTargetVerificationRequestDocument = lib_default`
    mutation sendEmailTargetVerificationRequest($targetId: String!) {
  sendEmailTargetVerificationRequest(
    sendTargetConfirmationRequestInput: {targetId: $targetId}
  ) {
    ...EmailTargetFragment
  }
}
    ${EmailTargetFragmentFragmentDoc}`;
var UpdateSourceGroupDocument = lib_default`
    mutation updateSourceGroup($id: String!, $name: String!, $sourceIds: [String!]!) {
  updateSourceGroup: createSourceGroup(
    sourceGroupInput: {id: $id, name: $name, sourceIds: $sourceIds}
  ) {
    ...SourceGroupFragment
  }
}
    ${SourceGroupFragmentFragmentDoc}`;
var UpdateTargetGroupDocument = lib_default`
    mutation updateTargetGroup($id: String!, $name: String!, $emailTargetIds: [String!]!, $smsTargetIds: [String!]!, $telegramTargetIds: [String!]!, $webhookTargetIds: [String!]!) {
  updateTargetGroup: createTargetGroup(
    targetGroupInput: {id: $id, name: $name, emailTargetIds: $emailTargetIds, smsTargetIds: $smsTargetIds, telegramTargetIds: $telegramTargetIds, webhookTargetIds: $webhookTargetIds}
  ) {
    ...TargetGroupFragment
  }
}
    ${TargetGroupFragmentFragmentDoc}`;
var FindTenantConfigDocument = lib_default`
    query findTenantConfig($input: FindTenantConfigInput!) {
  findTenantConfig(findTenantConfigInput: $input) {
    ...TenantConfigFragment
  }
}
    ${TenantConfigFragmentFragmentDoc}`;
var GetAlertsDocument = lib_default`
    query getAlerts {
  alert {
    ...AlertFragment
  }
}
    ${AlertFragmentFragmentDoc}`;
var GetConfigurationForDappDocument = lib_default`
    query getConfigurationForDapp($dappAddress: String!) {
  configurationForDapp(getConfigurationForDappInput: {dappAddress: $dappAddress}) {
    supportedSmsCountryCodes
    supportedTargetTypes
  }
}
    `;
var GetEmailTargetsDocument = lib_default`
    query getEmailTargets {
  emailTarget {
    ...EmailTargetFragment
  }
}
    ${EmailTargetFragmentFragmentDoc}`;
var GetFiltersDocument = lib_default`
    query getFilters {
  filter {
    ...FilterFragment
  }
}
    ${FilterFragmentFragmentDoc}`;
var GetNotificationHistoryDocument = lib_default`
    query getNotificationHistory($after: String, $first: Int) {
  notificationHistory(after: $after, first: $first) {
    nodes {
      ...NotificationHistoryEntryFragment
    }
    pageInfo {
      ...PageInfoFragment
    }
  }
}
    ${NotificationHistoryEntryFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;
var GetSmsTargetsDocument = lib_default`
    query getSmsTargets {
  smsTarget {
    ...SmsTargetFragment
  }
}
    ${SmsTargetFragmentFragmentDoc}`;
var GetSourceGroupsDocument = lib_default`
    query getSourceGroups {
  sourceGroup {
    ...SourceGroupFragment
  }
}
    ${SourceGroupFragmentFragmentDoc}`;
var GetSourcesDocument = lib_default`
    query getSources {
  source {
    ...SourceFragment
  }
}
    ${SourceFragmentFragmentDoc}`;
var GetTargetGroupsDocument = lib_default`
    query getTargetGroups {
  targetGroup {
    ...TargetGroupFragment
  }
}
    ${TargetGroupFragmentFragmentDoc}`;
var GetTelegramTargetsDocument = lib_default`
    query getTelegramTargets {
  telegramTarget {
    ...TelegramTargetFragment
  }
}
    ${TelegramTargetFragmentFragmentDoc}`;
var GetTopicsDocument = lib_default`
    query getTopics {
  topics {
    nodes {
      ...UserTopicFragment
    }
  }
}
    ${UserTopicFragmentFragmentDoc}`;
var GetWebhookTargetsDocument = lib_default`
    query getWebhookTargets {
  webhookTarget {
    ...WebhookTargetFragment
  }
}
    ${WebhookTargetFragmentFragmentDoc}`;
var defaultWrapper = (action, _operationName, _operationType) => action();
function getSdk(client, withWrapper = defaultWrapper) {
  return {
    beginLogInByTransaction(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(BeginLogInByTransactionDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "beginLogInByTransaction", "mutation");
    },
    broadcastMessage(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(BroadcastMessageDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "broadcastMessage", "mutation");
    },
    completeLogInByTransaction(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(CompleteLogInByTransactionDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "completeLogInByTransaction", "mutation");
    },
    createAlert(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(CreateAlertDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "createAlert", "mutation");
    },
    createEmailTarget(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(CreateEmailTargetDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "createEmailTarget", "mutation");
    },
    createSmsTarget(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(CreateSmsTargetDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "createSmsTarget", "mutation");
    },
    createSource(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(CreateSourceDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "createSource", "mutation");
    },
    createSourceGroup(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(CreateSourceGroupDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "createSourceGroup", "mutation");
    },
    createTargetGroup(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(CreateTargetGroupDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "createTargetGroup", "mutation");
    },
    createTelegramTarget(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(CreateTelegramTargetDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "createTelegramTarget", "mutation");
    },
    createWebhookTarget(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(CreateWebhookTargetDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "createWebhookTarget", "mutation");
    },
    deleteAlert(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(DeleteAlertDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "deleteAlert", "mutation");
    },
    deleteSourceGroup(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(DeleteSourceGroupDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "deleteSourceGroup", "mutation");
    },
    deleteTargetGroup(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(DeleteTargetGroupDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "deleteTargetGroup", "mutation");
    },
    logInFromDapp(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(LogInFromDappDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "logInFromDapp", "mutation");
    },
    refreshAuthorization(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(RefreshAuthorizationDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "refreshAuthorization", "mutation");
    },
    sendEmailTargetVerificationRequest(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(SendEmailTargetVerificationRequestDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "sendEmailTargetVerificationRequest", "mutation");
    },
    updateSourceGroup(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(UpdateSourceGroupDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "updateSourceGroup", "mutation");
    },
    updateTargetGroup(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(UpdateTargetGroupDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "updateTargetGroup", "mutation");
    },
    findTenantConfig(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(FindTenantConfigDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "findTenantConfig", "query");
    },
    getAlerts(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(GetAlertsDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "getAlerts", "query");
    },
    getConfigurationForDapp(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(GetConfigurationForDappDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "getConfigurationForDapp", "query");
    },
    getEmailTargets(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(GetEmailTargetsDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "getEmailTargets", "query");
    },
    getFilters(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(GetFiltersDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "getFilters", "query");
    },
    getNotificationHistory(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(GetNotificationHistoryDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "getNotificationHistory", "query");
    },
    getSmsTargets(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(GetSmsTargetsDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "getSmsTargets", "query");
    },
    getSourceGroups(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(GetSourceGroupsDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "getSourceGroups", "query");
    },
    getSources(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(GetSourcesDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "getSources", "query");
    },
    getTargetGroups(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(GetTargetGroupsDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "getTargetGroups", "query");
    },
    getTelegramTargets(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(GetTelegramTargetsDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "getTelegramTargets", "query");
    },
    getTopics(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(GetTopicsDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "getTopics", "query");
    },
    getWebhookTargets(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(GetWebhookTargetsDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "getWebhookTargets", "query");
    }
  };
}

// lib/NotifiService.ts
var NotifiService = class {
  constructor(graphQLClient) {
    this._typedClient = getSdk(graphQLClient);
  }
  setJwt(jwt) {
    this._jwt = jwt;
  }
  async logOut() {
    this._jwt = void 0;
  }
  async beginLogInByTransaction(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.beginLogInByTransaction(variables, headers);
  }
  async broadcastMessage(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.broadcastMessage(variables, headers);
  }
  async completeLogInByTransaction(variables) {
    var _a, _b;
    const headers = this._requestHeaders();
    const result = await this._typedClient.completeLogInByTransaction(
      variables,
      headers
    );
    const token = (_b = (_a = result.completeLogInByTransaction) == null ? void 0 : _a.authorization) == null ? void 0 : _b.token;
    if (token !== void 0) {
      this._jwt = token;
    }
    return result;
  }
  async createAlert(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.createAlert(variables, headers);
  }
  async createEmailTarget(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.createEmailTarget(variables, headers);
  }
  async createSmsTarget(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.createSmsTarget(variables, headers);
  }
  async createSource(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.createSource(variables, headers);
  }
  async createSourceGroup(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.createSourceGroup(variables, headers);
  }
  async createTargetGroup(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.createTargetGroup(variables, headers);
  }
  async createWebhookTarget(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.createWebhookTarget(variables, headers);
  }
  async createTelegramTarget(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.createTelegramTarget(variables, headers);
  }
  async deleteAlert(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.deleteAlert(variables, headers);
  }
  async deleteSourceGroup(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.deleteSourceGroup(variables, headers);
  }
  async deleteTargetGroup(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.deleteTargetGroup(variables, headers);
  }
  async findTenantConfig(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.findTenantConfig(variables, headers);
  }
  async getAlerts(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.getAlerts(variables, headers);
  }
  async getConfigurationForDapp(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.getConfigurationForDapp(variables, headers);
  }
  async getEmailTargets(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.getEmailTargets(variables, headers);
  }
  async getFilters(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.getFilters(variables, headers);
  }
  async getNotificationHistory(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.getNotificationHistory(variables, headers);
  }
  async getSmsTargets(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.getSmsTargets(variables, headers);
  }
  async getSourceGroups(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.getSourceGroups(variables, headers);
  }
  async getSources(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.getSources(variables, headers);
  }
  async getTargetGroups(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.getTargetGroups(variables, headers);
  }
  async getTelegramTargets(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.getTelegramTargets(variables, headers);
  }
  async getTopics(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.getTopics(variables, headers);
  }
  async getWebhookTargets(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.getWebhookTargets(variables, headers);
  }
  async logInFromDapp(variables) {
    var _a, _b;
    const headers = this._requestHeaders();
    const result = await this._typedClient.logInFromDapp(variables, headers);
    const token = (_b = (_a = result.logInFromDapp) == null ? void 0 : _a.authorization) == null ? void 0 : _b.token;
    if (token !== void 0) {
      this._jwt = token;
    }
    return result;
  }
  async refreshAuthorization(variables) {
    var _a;
    const headers = this._requestHeaders();
    const result = await this._typedClient.refreshAuthorization(
      variables,
      headers
    );
    const token = (_a = result.refreshAuthorization) == null ? void 0 : _a.token;
    if (token !== void 0) {
      this._jwt = token;
    }
    return result;
  }
  async sendEmailTargetVerificationRequest(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.sendEmailTargetVerificationRequest(
      variables,
      headers
    );
  }
  async updateSourceGroup(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.updateSourceGroup(variables, headers);
  }
  async updateTargetGroup(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.updateTargetGroup(variables, headers);
  }
  _requestHeaders() {
    const requestId = uuid();
    const headers = { "X-Request-Id": requestId };
    if (this._jwt !== void 0) {
      headers["Authorization"] = `Bearer ${this._jwt}`;
    }
    return headers;
  }
};
export {
  NotifiService
};
